
import Component, { mixins } from "vue-class-component"
import {
  AbholzeitType,
  Bezahlart,
  LoadState,
  Terminart,
  Verzehrart,
} from "mangdto"
import Calculator from "../mixins/Calculator.vue"
import ArtikelRow from "../custom/ArtikelRow.vue"
import FilialeHeader from "../custom/FilialeHeader.vue"
import NichtGueltig from "../custom/NichtGueltig.vue"
import BestaetigenLogic from "@/logic/bestellung_neu/bestaetigen_logic"
import BestaetigenSofort from "./BestaetigenSofort.vue"

@Component({
  components: {
    BestaetigenSofort,
    // BestaetigenReservierung,
    ArtikelRow,
    FilialeHeader,
    NichtGueltig,
  },
})
export default class BestaetigenAbholung2 extends mixins(Calculator) {
  $refs!: {
    form: HTMLFormElement
  }

  Terminart = Terminart
  AbholzeitType = AbholzeitType
  Bezahlart = Bezahlart

  logic: BestaetigenLogic = null

  agbRules: any[] = [
    (v: boolean) => {
      if (!v) return "Bitte die AGB akzeptieren"
    },
  ]

  bezahlartRules: any[] = [
    (v: boolean) => {
      if (!v) return "Bitte Bezahlart wählen"
    },
  ]

  berechneVerzehrart() {
    switch (this.logic.abholungData.verzehrart) {
      case Verzehrart.VorOrt:
        return "Verzehr im Restaurant"
      case Verzehrart.Mitnahme:
        return "Zum Mitnehmen"
    }
  }

  berechneTisch() {
    if (this.logic.abholungData.tischBezeichnung) {
      return this.logic.abholungData.tischBezeichnung
    }
    return "---"
  }

  agbAnzeigen() {
    this.logic.agbAnzeigen()
  }

  get bestaetigenLoading() {
    return this.logic.bestaetigenLoadState == LoadState.Loading
  }

  mounted() {
    this.logic = new BestaetigenLogic()
    this.logic.init()
  }

  bestellungBestaetigen() {
    var valid = this.$refs.form.validate()
    if (!valid) return

    this.logic.bestellungBestaetigen()
  }
}
